<template>
  <div class="layout-wrapper">
    <Header />

    <main class="layout-main">
      <Sidebar />
      <div class="layout-router-view">
        <div class="alert-message-wrapper" :style="{'background-color': alertBackgroundColor}" v-if="alertMessage && !alertMessageClosedLocal">
          <div class="row alert-message">
            <div class="alert-message col-11" @click="alertMessageClicked">{{ alertMessage.Message }}</div>
            <div class="alert-message-close col-1">
              <!-- <button @click="closeAlertMessage" class="icon-btn"> -->
                <i @click="closeAlertMessage" class="fa fa-times-circle pointer" aria-hidden="true"></i>
              <!-- </button> -->
            </div>
          </div>
        </div>
        <router-view class="route"/>
      </div>
			<Modal ref="alertDialog" width="800" transition="fade-transition">
					<div class="message-dialog">
							<MarkdownMessageDialog
									v-bind:title="title"
									v-bind:message="message"
									v-bind:color="color"
									v-on:close-dialog="closeDialog"
							></MarkdownMessageDialog>
					</div>
			</Modal>
				<Modal ref="tosModal" :disable_background_click_to_close="true">
						<div class="card modal-wrapper p-4 tos-modal">
								<h5>Account Holder Confirmation</h5>
								<!-- Placeholder copy pending final client wording (#2026-107) -->
								<p>By logging in to SmartSalesTool you confirm that you are the licensed account holder. Account sharing is a violation of the SmartSalesTool Terms of Service and may result in immediate account suspension without refund. If you believe your account has been accessed by an unauthorized person, contact support immediately.</p>
								<div class="form-check mb-3">
										<input type="checkbox" class="form-check-input" id="tosCheckbox" v-model="tosChecked">
										<label class="form-check-label" for="tosCheckbox">I understand that I am the sole authorized user of this account and agree to the Terms of Service.</label>
								</div>
								<button class="btn btn-primary col-12" :disabled="!tosChecked" @click="acceptTos">Activate Account</button>
						</div>
				</Modal>
    </main>
  </div>
</template>
<script>

import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header.vue';
import MarkdownMessageDialog from '../../components/MarkdownMessageDialog.vue';

import { mapState } from 'vuex';

export default {
  components:{
    Header,
    Sidebar,
    MarkdownMessageDialog,
},
  data(){
    return{
      alertMessageClosedLocal: false,
      alertMessageOneTimeLocal: false,
      bannerPollInterval: null,
      tosChecked: false,
    }
  },
  computed: {
    ...mapState(['alertMessage', 'alertMessageClosed', 'alertBackgroundColor']),
		requiresTosAcceptance() {
			return this.$store.state.currentUser?.RequiresTosAcceptance;
		},
		title() {
			return this.alertMessage?.MessageTitle;
		},
		message() {
			return this.alertMessage?.MessageBody;
		},
		color() {
			return this.alertMessage?.BackgroundColor;
		}
  },
  methods: {
    closeAlertMessage(){
      if (this.alertMessageOneTimeLocal) {
        localStorage.setItem('alertMessageClosed', 'true');
      }

      this.$store.dispatch('SET_ALERT_MESSAGE_CLOSED', true);
      this.alertMessageClosedLocal = true;
    },
		alertMessageClicked() {
			this.$refs.alertDialog.openModal();
		},
		closeDialog() {
			this.$refs.alertDialog.closeModal();
		},
		acceptTos() {
			if (!this.tosChecked) return;
			this.$store.dispatch('ACCEPT_TOS').then(() => {
				this.$refs.tosModal.closeModal();
			}).catch(err => {
				console.log(err);
			});
		}
  },
  watch: {
    requiresTosAcceptance: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$refs.tosModal?.openModal();
        }
      }
    }
  },
  created() {
    // Handle null/undefined localStorage values properly
    const alertClosed = localStorage.getItem('alertMessageClosed');
    this.alertMessageClosedLocal = alertClosed ? JSON.parse(alertClosed) : false;
    this.alertMessageOneTimeLocal = localStorage.getItem('alertMessageIsOneTime') === 'true';
  },
  mounted() {
    // In case currentUser (with RequiresTosAcceptance = true) was already loaded before this component mounted
    if (this.requiresTosAcceptance) {
      this.$refs.tosModal?.openModal();
    }

    // Poll for banner and notification updates every 60 seconds
    this.bannerPollInterval = setInterval(() => {
      this.$store.dispatch('GET_ALERT_MESSAGE');
      this.$store.dispatch('GET_USER_NOTIFICATIONS');
    }, 60000);
  },
  beforeDestroy() {
    // Clean up the polling interval
    if (this.bannerPollInterval) {
      clearInterval(this.bannerPollInterval);
    }
  }
};
</script>

<style lang="scss" scoped>
  .layout-wrapper {
    min-height: 100%;
    // max-width: 1500px;
    /*margin: auto;*/
    background: $white;

    .layout-main {
      height: calc(100vh - 50px);
      display: flex;
    }
    .layout-router-view {
      width: 100%;
      overflow: scroll;
      .alert-message-wrapper{
        min-height: 25px;
        width: 100%;
        color: black;
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow-wrap: anywhere;
        padding: 10px;
        .alert-message{
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
					cursor: pointer;
        }
        .alert-message-close{
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
      .route{
        padding: 15px 30px;
      }
    }

		.message-dialog {
        width: 600px;
        display: flex;
        font-size: 1.2em;
        justify-content: space-around;
        align-items: center;
        .modal-text{
          text-align: center;
          margin-top: 10px;
          margin-bottom: 0px;
        }
        .btn-wrapper{
            margin-top: 25px;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            .btn{
              min-height: 100%;
              min-width: 125px;
            }
            &.center{
                justify-content: space-around;
                align-items: center;
            }
        }
    }

    .tos-modal {
      max-width: 650px;

      p, .form-check-label {
        color: #212529;
      }
    }
  }
</style>
